export default [
  {
    path: '/users',
    meta: {
      auth: true,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'users',
        component: () => import('~/users/pages/Index.vue'),
      },
      {
        path: '/users/view/:id',
        name: 'ViewUser',
        component: () => import('~/users/pages/View.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
      {
        path: '/user/profile/:id',
        name: 'ProfileUser',
        component: () => import('~/users/pages/Profile.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
    ],
  },
];
